<template>
    <div v-if="paginator?.meta?.links?.length" class="text-small pagination flex justify-end">
        <div class="flex items-center" style="gap: 16px">
            <div v-if="paginator.meta.total > 0">
                {{
                    trans('pagination.description', {
                        from: paginator.meta.from,
                        to: paginator.meta.to,
                        total: paginator.meta.total,
                    })
                }}
            </div>
            <div v-if="paginator.meta.links.length > 1" class="flex gap-1">
                <a
                    :class="{
                        disabled: !paginator.links.prev,
                        'text-secondary': !paginator.links.prev,
                    }"
                    :href="paginator.links.prev"
                    class="btn btn-icon border-0"
                    @click.prevent="updateActivePage(paginator.meta.current_page - 1)"
                >
                    <chevron-left />
                </a>
                <a
                    :class="{
                        disabled: !paginator.links.next,
                        'text-secondary': !paginator.links.next,
                    }"
                    :href="paginator.links.next"
                    class="btn btn-icon border-0"
                    @click.prevent="updateActivePage(paginator.meta.current_page + 1)"
                >
                    <chevron-right />
                </a>
            </div>
        </div>
    </div>
</template>
<script setup>
import ChevronLeft from '@/../icons/ChevronLeft.vue';
import ChevronRight from '@/../icons/ChevronRight.vue';
import { trans } from '../mixins/i18n.js';

const props = defineProps({
    paginator: Object,
    queryParams: Object,
});

const updateActivePage = (page) => {
    if (!page || page > props.paginator.meta.last_page) {
        return;
    }

    props.queryParams.form.page = page;
    props.queryParams.change();
};
</script>
